<div id="shared-checkbox-card-container" class="shared-checkbox-card-container">
  <app-card id="shared-checkbox-card" class="checkbox-card" padding="0">
    <div
      class="card-content"
      id="shared-checkbox-card-content"
      [ngClass]="{ 'checked-card-content': isChecked }"
    >
      <div id="shared-checkbox-card-checkbox-container" class="card-checkbox">
        <app-checkbox
          id="shared-checkbox-card-checkbox"
          [defaultChecked]="isChecked"
          [checkboxData]="''"
          [checkboxId]="checkboxId"
          (checkboxCheck)="onCheck($event)"
        ></app-checkbox>
      </div>

      <div
        id="shared-checkbox-card-content-details-container"
        class="card-content-details"
      >
        <ng-container
          id="shared-checkbox-card-content-details"
          *ngFor="let card of cardData; let i = index"
        >
          <div
            id="shared-checkbox-card-key-value-container"
            [ngClass]="{
              'card-content-flex': true,
              'card-content-two-columns-flex': cardData.length === 2 && i === 1
            }"
          >
            <app-title-subtitle
              [id]="'shared-checkbox-card-title-subtitle-' + i"
              [title]="card?.key || '' | translate | uppercase"
              [subtitle]="card?.value!"
              [titleFontStyle]="'overline'"
              [subtitleFontStyle]="'headline3'"
            ></app-title-subtitle>
          </div>
        </ng-container>
      </div>
    </div>
  </app-card>
</div>
